const resolveBaseUrl = () => {
    const configuredBaseUrl = process.env.REACT_APP_API_URL;

    if (configuredBaseUrl) {
        return configuredBaseUrl;
    }

    return "";
};

export const BASE_URL = resolveBaseUrl();
export const PRODUCTS_URL = "/api/products";
export const USERS_URL = "/api/users";
export const ORDERS_URL = "/api/orders";
export const PAYPAL_URL = "/api/config/paypal";
